import { BearingEnvelope, Point2D } from '@paragon/contract-library';

import { InsertionBearingEnvelope } from '../../../store/slices/applicationSlice';

export function createPreviewBearingEnvelope(
  data: InsertionBearingEnvelope,
  overridePoints?: { leftPoint?: Point2D; rightPoint?: Point2D },
): BearingEnvelope {
  return {
    ...data,
    numberOfPlies: data.numberOfPlies ?? 1,

    name: '',
    guid: crypto.randomUUID(),

    // validating the combination of the insertion data and the provided points is the responsibility of the caller

    leftPoint: (overridePoints?.leftPoint ?? data.leftPoint) as Point2D,
    rightPoint: (overridePoints?.rightPoint ?? data.rightPoint) as Point2D,
  };
}
